import React, { FC, PropsWithChildren } from "react";
import { createUseStyles } from "react-jss";

interface ViewProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: any;
  onDrag?: (event: React.DragEvent<HTMLDivElement>) => void;
  onScroll?: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
  refPassed?: React.MutableRefObject<HTMLDivElement>;
  onKeyPress?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  onMouseEnter?: any;
  onMouseLeave?: any;
  id?: string;
  dataTestId?: string;
  ariaLabel?: string;
  title?: string;
}

const useStyles = createUseStyles({
  view: (props: { style: React.CSSProperties | undefined }) => ({
    ...(props.style || {}),
    display: "flex",
    flexDirection: "column",
    "-webkit-flex-direction": "column",
    outline: "none",
  }),
  pointer: {
    cursor: "pointer",
    border: 0,
  },
});

const View: FC<PropsWithChildren<ViewProps>> = ({
  children,
  className = "",
  style,
  onClick = undefined,
  onDrag = undefined,
  onScroll = undefined,
  refPassed = undefined,
  onKeyPress = undefined,
  id = undefined,
  dataTestId = null,
  ariaLabel = undefined,
  title = undefined,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
  ...props
}) => {
  const styles = useStyles({ style });

  return onClick ? (
    <div
      className={`${styles.view} ${styles.pointer} ${className} flexCompatibility`}
      onClick={onClick}
      onScroll={onScroll}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
      ref={refPassed}
      onKeyPress={onKeyPress}
      id={id}
      key={id}
      aria-label={ariaLabel}
      title={title}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onDrag={onDrag}
      data-testid={dataTestId}
      style={style}
      {...props}
    >
      {children}
    </div>
  ) : (
    <div
      id={id}
      data-testid={dataTestId}
      aria-label={ariaLabel}
      title={title}
      onDrag={onDrag}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={refPassed}
      onScroll={onScroll}
      className={`${styles.view} ${className} flexCompatibility`}
      key={id}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

export default React.memo(View);
